import { IkasPaymentMethodType } from "../../payment-gateway";
import { IkasTransactionError } from "./error";
import { IkasTransactionPaymentMethodDetail } from "./payment-method-detail";

export type IkasOrderTransaction = {
  amount: number | null;
  checkoutId: string | null;
  createdAt: number | null;
  currencyCode: string | null;
  currencySymbol: string | null;
  customerId: string | null;
  error: IkasTransactionError | null;
  id: string | null;
  orderId: string | null;
  paymentGatewayId: string | null;
  paymentGatewayName: string | null;
  paymentMethod: IkasPaymentMethodType | null;
  paymentMethodDetail: IkasTransactionPaymentMethodDetail | null;
  processedAt: number | null;
  refundReason: string | null;
  status: IkasTransactionStatus | null;
  type: IkasTransactionType | null;
  updatedAt: number | null;
};

export enum IkasTransactionStatus {
  AUTHORIZED = "AUTHORIZED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}

export enum IkasTransactionType {
  REFUND = "REFUND",
  SALE = "SALE",
  VOID = "VOID",
}
